import React from 'react';
import { I18n } from '@aws-amplify/core';

import { InfoCircleIcon } from '@/assets/icons/v2';

import { STRETCH_ISSUE } from './coverage';
import { RevisionAlert } from './styles';

import type { StretchIssue } from './coverage';

const INTRO = 'The TLIDs shown were extracted from the last evaluation.';

type IssueCopy = {
	highlight: string;
	separator: string;
	tail: string;
};

const ISSUE_COPY: Record<StretchIssue, IssueCopy> = {
	[STRETCH_ISSUE.EXCEEDS_VIDEO]: {
		highlight: 'The grey stretches belong to the previous video and are outside the current video range',
		separator: '. ',
		tail: 'Adjust the periods to reuse them.'
	},
	[STRETCH_ISSUE.INCOMPLETE_COVERAGE]: {
		highlight: 'The video has unidentified stretches',
		separator: '',
		tail: ', adjust the periods to complete the identification.'
	}
};

interface RevisionBannerProps {
	issue: StretchIssue;
}

export function RevisionBanner({ issue }: Readonly<RevisionBannerProps>): JSX.Element {
	const { highlight, separator, tail } = ISSUE_COPY[issue];

	const message = (
		<>
			{`${I18n.get(INTRO)} `}
			<strong>{I18n.get(highlight)}</strong>
			{separator}
			{I18n.get(tail)}
		</>
	);

	return <RevisionAlert closable showIcon type="info" icon={<InfoCircleIcon />} message={message} />;
}
